<template>
	<div ref="main" style="height: 100vh; overflow: auto" v-infinite-scroll="loadMore"
		:infinite-scroll-immediate-check="true" infinite-scroll-distance="10" @scroll="handleScroll"
		@click="removeInputState()">

		<div class="general_back_top" v-if="isShowScrollBtn" @click="scrollToTop">
			<img class="icon" src="../assets/image/shang.png" alt="" />
			<div>返回顶部</div>
		</div>

		<top-nav ref="topNav" @scrollToTop="scrollToTop" :isShowScrollBtn="isShowScrollBtn" :isShowNav="isShowNav"
			:isInputing="isInputing" />
		<transition enter-active-class="animate__animated animate__fadeIn"
			leave-active-class="animate__animated animate__fadeOut" mode="out-in" duration="300" appear>
			<router-view @updateCartProductCount="updateCartProductCount($event)" />
		</transition>
		<foo-ter />
	</div>
</template>

<script>
	import topNav from "../views/Home/Home.vue";
	import fooTer from "../components/footer.vue";
	import ElBacktop from 'element-ui/packages/backtop/src/main'
	import "animate.css";

	export default {
		components: {
			topNav,
			fooTer,
		},

		data() {
			return {
				isShowNav: false,
				isInputing: false,
				isShowScrollBtn: false,
			};
		},

		methods: {
			scrollToTop() {
				this.$refs.main.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			},
			updateCartProductCount(e) {
				this.$refs.topNav.updateCartProductCount(e);
				console.log('hzindex' + e)
				this.$forceUpdate();
			},
			removeInputState() {
				this.isInputing = false;
				// if (this.$refs.topNav) {
				//   this.$refs.topNav.input_blurIpt();
				// }
				this.$forceUpdate();
			},
			loadMore() {},
			handleScroll(e, item) {
				let scrollY = e.target.scrollTop;
				// console.log(e.target.scrollTop);
				var height = 90;
				if (scrollY >= height) {
					this.isShowNav = true;

					this.isInputing = false;
					// if (this.$refs.topNav) {
					//   this.$refs.topNav.input_blurIpt();
					// }
				} else {
					this.isShowNav = false;
				}

				this.isShowScrollBtn = scrollY > 200;
				this.$forceUpdate();
			},
		},
	};
</script>
<style lang="scss" scoped>
	.general_back_top {
		width: 80px;
		height: 80px;
		background: #000000;
		border-radius: 8px;
		border-radius: 8px;
		opacity: 0.3;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: fixed;
		bottom: 90px;
		right: 70px;
		cursor: pointer;
		z-index: 2000;
		font-size: 12px;
		color: #fff;

		.icon {
			width: 32px;
			height: auto
		}
	}
</style>